import i18next from 'i18next';
import {impostaContestoMolteplicita} from './molteplicita';
/**
 * Il profilo di gioco: l'unica fonte di quello che il giocatore puo' fare.
 *
 * DAL BACKOFFICE PARTE TUTTO. Qui dentro non ci sono numeri di ripiego: se un
 * valore non arriva, il controllo corrispondente NON SI FA — non si sostituisce
 * con una regola inventata dal browser. Un limite inventato qui e' peggio di
 * nessun limite, perche' il rifiuto vero arriva dal server a giocata mandata.
 *
 * Il contratto completo sta in lvc-docs/it/profilo-di-gioco.md.
 */

function indirizzoGateway() {
  const env = (typeof window !== 'undefined' && window.env) ? window.env : {};
  return env.REACT_APP_API_URL || 'http://localhost:9001';
}

function intestazioni() {
  const token = typeof window !== 'undefined'
    ? window.localStorage.getItem('access_token')
    : null;
  const h = {'Content-Type': 'application/json'};
  if (token) h.Authorization = `Bearer ${token}`;
  const tenant = typeof window !== 'undefined'
    && window.env && window.env.REACT_APP_API_TENANT;
  if (tenant) h.TENANT_ID = tenant;
  h['X-Client-Surface'] = 'FRONTEND';
  return h;
}

/**
 * Chiede il profilo di UN GIOCATORE.
 *
 * Quando un'agenzia compila per un suo giocatore qui va il GIOCATORE, non
 * l'agenzia: la scommessa e' sua e i limiti sono i suoi. Cambiando giocatore
 * nella tendina il profilo va richiesto.
 *
 * A QUALE BANCO. Il profilo non e' uno solo: a banco chiuso la riserva non
 * esiste e le soglie diventano tetti (lvc-docs, riserva.md, «Il banco chiuso
 * sulle giocate»). Chi COMPILA UNA GIOCATA chiede 'ADESSO': e' il solo
 * profilo che corrisponde ai controlli che il servizio fara' sulla giocata.
 * Chi non dice niente riceve le regole a banco aperto, cioe' come sono
 * scritte -- va bene a chi del profilo legge altro (le ultime giocate), non
 * a chi deve mostrare i limiti.
 *
 * SENZA CONTESTO. Leggere il profilo cambia due cose che valgono per tutta la
 * pagina: i colori e le regole di molteplicita' delle quote, e il motivo che
 * la schedina scrive quando il profilo manca. Chi legge il profilo per
 * un'altra ragione -- le regole di stampa e condivisione di chi guarda,
 * mentre la schedina mostra quelle del giocatore scelto -- passa
 * {senzaContesto: true} e non tocca ne' l'uno ne' l'altro.
 *
 * @param banco 'ADESSO' | 'APERTO' | 'CHIUSO', oppure niente
 * @param opzioni {senzaContesto: true} per leggere senza toccare il resto della pagina
 * @returns {Promise<Object|null>} il profilo, oppure null se non si e'
 *          riusciti a leggerlo. Null non significa "nessun limite": significa
 *          che non si sa, e senza saperlo non si gioca.
 */
export async function caricaProfilo(utente, canale = 'PREMATCH', banco, {senzaContesto = false} = {}) {
  if (!utente) return null;
  try {
    const url = `${indirizzoGateway()}/private/vincoli/profilo`
      + `?utente=${encodeURIComponent(utente)}&canale=${encodeURIComponent(canale)}`
      + (banco ? `&banco=${encodeURIComponent(banco)}` : '');
    const risposta = await fetch(url, {headers: intestazioni()});
    if (!risposta.ok) {
      /* IL CODICE E IL DETTAGLIO, non solo il numero: un 403 puo' essere
         dieci cose diverse, e senza sapere quale nessuno puo' fare niente.
         Il motivo viene tenuto da parte per scriverlo anche nella schedina:
         "riprova fra poco" non dice a nessuno cosa e' andato storto. */
      const corpo = await risposta.json().catch(() => null);
      const motivo = {
        code: (corpo && corpo.code) || `HTTP_${risposta.status}`,
        status: risposta.status,
        message: (corpo && corpo.message) || i18next.t('Limiti di gioco non disponibili'),
      };
      console.warn('[profilo] non disponibile:', motivo.code, motivo.status,
          motivo.message);
      if (!senzaContesto) ultimoMotivo = motivo;
      return null;
    }
    if (!senzaContesto) ultimoMotivo = null;
    const profilo = await risposta.json();
    // Colori e regole di molteplicita' per chi disegna le quote.
    if (!senzaContesto) impostaContestoMolteplicita(profilo);
    return profilo;
  } catch (errore) {
    console.warn('[profilo] non raggiungibile:', errore);
    if (!senzaContesto) {
      ultimoMotivo = {code: 'RETE', status: 0,
        message: i18next.t('Non si riesce a raggiungere il server')};
    }
    return null;
  }
}

/**
 * Quello che vede chi NON E' COLLEGATO: la tabella del bonus e i tasti
 * dell'importo della skin.
 *
 * Senza questo un visitatore compila una schedina senza bonus, e il numero gli
 * cambia sotto gli occhi appena entra. Non porta nessun limite -- un limite
 * non serve a chi non puo' giocare -- e nessun nome di nessuno.
 *
 * La skin non si dice: la manda gia' il sito nell'intestazione, come per tutte
 * le altre chiamate. Se non si riesce a leggerla si torna null e la schedina
 * resta com'era: senza bonus, non rotta.
 */
/* Due parti della pagina (la schedina e la pagina delle quote) la chiedono
   insieme all'apertura: due chiamate uguali a pochi millisecondi. Si tiene la
   stessa risposta per un minuto; un errore non si tiene.
   SENZA CONTESTO (vedi caricaProfilo) si usa la risposta tenuta se c'e' -- il
   suo contesto l'ha gia' impostato chi l'ha chiesta -- altrimenti si legge a
   parte e NON si tiene: chi arriva dopo senza l'opzione deve trovare una
   lettura che il contesto l'ha impostato davvero. */
let schedinaSkinInArrivo = null;
let schedinaSkinQuando = 0;

export function caricaSchedinaSkin({senzaContesto = false} = {}) {
  if (schedinaSkinInArrivo && Date.now() - schedinaSkinQuando < 60000) {
    return schedinaSkinInArrivo;
  }
  if (senzaContesto) return leggiSchedinaSkin({senzaContesto: true});
  schedinaSkinQuando = Date.now();
  schedinaSkinInArrivo = leggiSchedinaSkin().then((dato) => {
    if (!dato) schedinaSkinInArrivo = null;
    return dato;
  });
  return schedinaSkinInArrivo;
}

async function leggiSchedinaSkin({senzaContesto = false} = {}) {
  try {
    const risposta = await fetch(`${indirizzoGateway()}/public/vincoli/schedina`,
        {headers: intestazioni()});
    if (!risposta.ok) return null;
    const schedina = await risposta.json();
    if (!senzaContesto) impostaContestoMolteplicita(schedina);
    return schedina;
  } catch (errore) {
    console.warn('[profilo skin] non raggiungibile:', errore);
    return null;
  }
}

/* Perche' l'ultima richiesta del profilo non e' riuscita.
   Sta qui e non nello stato del componente perche' chi chiede il profilo e chi
   disegna l'avviso sono due posti diversi, e far passare un secondo valore di
   ritorno solo per questo avrebbe cambiato la firma a tutti. */
let ultimoMotivo = null;

/** L'ultimo motivo per cui il profilo non e' arrivato, o niente. */
export function motivoProfiloMancante() {
  return ultimoMotivo;
}

/** I limiti del tipo di coupon corrente. Nessun profilo = nessun limite noto. */
export function limitiDi(profilo, tipoCoupon) {
  if (!profilo || !profilo.coupon) return null;
  return profilo.coupon[tipoCoupon] || null;
}

/** Da come si chiama il tipo nella schedina al nome del contratto. */
export function tipoCouponDa(tipoSchedina, numeroSelezioni) {
  /* DUE SCHEDINE, DUE VOCABOLARI.
     Questa funzione era scritta per la vecchia (SportTicket), che dice
     'system' e 'integral'; la nuova dice 'sistema' e 'integrale'. Nessuna
     delle due parole combaciava, e il confronto cadeva in fondo rispondendo
     MULTIPLA -- senza errore, senza avviso: su un sistema la schedina
     mostrava i limiti della multipla, mentre il server applicava quelli del
     sistema. Il cliente leggeva un tetto di vincita e ne valeva un altro.
     Si accettano tutte e due le parole invece di sceglierne una: la vecchia
     schedina e' ancora viva, e un rinominamento di la' romperebbe di qua in
     silenzio esattamente come e' successo. */
  const t = String(tipoSchedina || '').toLowerCase();
  if (t === 'system' || t === 'sistema') return 'SISTEMA';
  if (t === 'integral' || t === 'integrale') return 'INTEGRALE';
  if (numeroSelezioni === 1) return 'SINGOLA';
  return 'MULTIPLA';
}

// ---------------------------------------------------------------------------
// I controlli
// ---------------------------------------------------------------------------

/**
 * Controlla le selezioni contro i limiti.
 *
 * Ogni controllo si fa SOLO se il valore c'e'. Un campo nullo significa nessun
 * controllo: non zero, non un valore di riserva.
 *
 * @returns {{valido: boolean, errori: string[], profiloAssente: boolean}}
 */
export function controllaSelezioni(selezioni, limiti) {
  const errori = [];

  if (!Array.isArray(selezioni) || selezioni.length === 0) {
    return {valido: false, errori: [i18next.t('Nessuna selezione nella schedina')], profiloAssente: false};
  }

  // Senza profilo non si dichiara valido: si dichiara ignoto, e chi chiama
  // spegne il pulsante e lo dice. Continuare vorrebbe dire far compilare una
  // schedina che il server rifiutera'.
  if (!limiti) {
    return {valido: false, errori: [], profiloAssente: true};
  }

  const n = selezioni.length;

  if (limiti.eventiMin != null && n < limiti.eventiMin) {
    errori.push(messaggio(limiti, 'EVENTI_MIN',
      `Servono almeno ${limiti.eventiMin} ${limiti.eventiMin === 1 ? 'evento' : 'eventi'}`));
  }
  if (limiti.eventiMax != null && n > limiti.eventiMax) {
    errori.push(messaggio(limiti, 'EVENTI_MAX',
      i18next.t('Puoi giocare al massimo {{eventiMax}} eventi', {eventiMax: limiti.eventiMax})));
  }

  if (limiti.quotaMinSelezione != null) {
    const bassa = quote(selezioni).find((q) => q > 0 && q < limiti.quotaMinSelezione);
    if (bassa !== undefined) {
      errori.push(messaggio(limiti, 'QUOTA_MIN_SELEZIONE',
        i18next.t('La quota minima giocabile e\' {{v0}}', {v0: formato(limiti.quotaMinSelezione)})));
    }
  }
  if (limiti.quotaMaxSelezione != null) {
    const alta = quote(selezioni).find((q) => q > limiti.quotaMaxSelezione);
    if (alta !== undefined) {
      errori.push(messaggio(limiti, 'QUOTA_MAX_SELEZIONE',
        i18next.t('La quota massima giocabile e\' {{v0}}', {v0: formato(limiti.quotaMaxSelezione)})));
    }
  }

  return {valido: errori.length === 0, errori, profiloAssente: false};
}

/** Controlla l'importo. Separato perche' cambia a ogni tasto, le selezioni no. */
export function controllaImporto(importo, limiti) {
  const errori = [];
  if (!limiti) return {valido: false, errori: [], profiloAssente: true};

  const n = Number(importo);
  if (!(n > 0)) {
    return {valido: false, errori: [i18next.t('Scrivi un importo')], profiloAssente: false};
  }
  if (limiti.importoMin != null && n < limiti.importoMin) {
    errori.push(messaggio(limiti, 'IMPORTO_MIN',
      i18next.t('L\'importo minimo e\' {{v0}}', {v0: formato(limiti.importoMin)})));
  }
  if (limiti.importoMax != null && n > limiti.importoMax) {
    errori.push(messaggio(limiti, 'IMPORTO_MAX',
      i18next.t('L\'importo massimo e\' {{v0}}', {v0: formato(limiti.importoMax)})));
  }
  return {valido: errori.length === 0, errori, profiloAssente: false};
}

/**
 * Il messaggio scritto sul vincolo vince su quello nostro: e' quello che
 * l'operatore ha deciso di far leggere al giocatore.
 */
function messaggio(limiti, quale, nostro) {
  const o = limiti.origine && limiti.origine[quale];
  return (o && o.messaggio) ? o.messaggio : nostro;
}

function quote(selezioni) {
  const valori = [];
  (selezioni || []).forEach((s) => {
    (s.markets || []).forEach((m) => {
      (m.odds || []).forEach((o) => {
        const v = parseFloat(o.value !== undefined ? o.value : o.odd);
        if (!Number.isNaN(v)) valori.push(v);
      });
    });
  });
  return valori;
}

function formato(n) {
  return Number(n).toFixed(2).replace('.', ',');
}

// ---------------------------------------------------------------------------
// Il bonus multipla
// ---------------------------------------------------------------------------

/**
 * Quanti eventi di una colonna CONTANO per il bonus.
 *
 * Una selezione sotto la quota minima dello scalino non conta: una multipla da
 * sei con due selezioni a 1.10 prende lo scalino da quattro, non da sei.
 */
export function eventiValidi(quoteColonna, quotaMinima) {
  if (quotaMinima == null) return (quoteColonna || []).length;
  return (quoteColonna || []).filter((q) => Number(q) >= Number(quotaMinima)).length;
}

/**
 * LE QUOTE CHE CONTANO PER IL BONUS.
 *
 * Una partita che si gioca oltre N giorni non aiuta ad arrivare allo scalino:
 * resta nella giocata e la sua quota moltiplica come tutte le altre -- quella
 * la calcola chi fa il prodotto, non questa funzione -- ma non si conta.
 *
 * UNA DATA CHE NON SAPPIAMO CONTA. E' il contrario della regola dei bersagli,
 * dove un campo che non si misura non prende: li' non misurare vuol dire non
 * limitare, qui vorrebbe dire togliere soldi al cliente per un buco nostro.
 *
 * E' lo stesso filtro che fa il server in WinCalculator.quoteDi(): se i due
 * divergono, il cliente legge un bonus e ne incassa un altro.
 */
export function quoteCheContano(quote, giorniMassimi) {
  const tutte = (quote || []).map((q) => q.valore);
  if (!giorniMassimi || !(Number(giorniMassimi) > 0)) return tutte;

  const limite = Date.now() + Number(giorniMassimi) * 24 * 60 * 60 * 1000;
  return (quote || [])
      .filter((q) => {
        if (!q.inizio) return true;
        const quando = new Date(q.inizio).getTime();
        return Number.isNaN(quando) || quando <= limite;
      })
      .map((q) => q.valore);
}

/** Lo scalino scritto per quel numero di eventi, anche se spento. */
function passo(scalini, eventi) {
  if (!Array.isArray(scalini)) return null;
  return scalini.find((x) => Number(x.eventi) === Number(eventi)) || null;
}

/**
 * Quale scalino spetta a una colonna.
 *
 * Si parte dal conteggio pieno e si scende: il primo scalino che la colonna
 * RAGGIUNGE, contando solo le selezioni sopra la quota minima di QUELLO
 * scalino, e' quello buono. Cosi' la quota minima puo' anche essere diversa da
 * scalino a scalino senza che il conto diventi circolare.
 */
export function scalinoApplicabile(scalini, quoteColonna) {
  const totale = (quoteColonna || []).length;
  for (let e = totale; e >= 0; e -= 1) {
    const s = passo(scalini, e);
    if (!s) continue;
    if (eventiValidi(quoteColonna, s.quotaMinima) >= e) return s;
  }
  return null;
}

/**
 * Il bonus di UNA colonna, sulla vincita LORDA (posta compresa).
 *
 * Il bonus si calcola per COLONNA, non per schedina: in un sistema 4-uple +
 * 5-uple le quaterne prendono lo scalino da quattro (che puo' essere zero) e
 * solo la cinquina prende quello da cinque. Verificato sui numeri veri:
 * 1463.01 x 5% = 73.15, e le quaterne prendono zero.
 */
export function bonusColonna(quotaColonna, importoColonna, quoteColonna, scalini) {
  const scalino = scalinoApplicabile(scalini, quoteColonna);
  // Percentuale zero significa scalino spento: non serve un campo a parte.
  if (!scalino || !(Number(scalino.percentuale) > 0)) return 0;
  const lordo = Number(quotaColonna) * Number(importoColonna);
  return arrotonda((lordo * Number(scalino.percentuale)) / 100);
}

/** Due decimali, al piu' vicino. E' la regola dichiarata nel regolamento. */
export function arrotonda(n) {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

/**
 * L'importo totale ripartito fra le colonne, SENZA PERDERE UN CENTESIMO.
 *
 * Due euro su sei colonne non si dividono in parti uguali: 0,3333 a testa non
 * e' un importo che esiste. Dividere e basta vuol dire scegliere fra due cose
 * sbagliate -- tagliare a 0,33 e far giocare 1,98 a chi ha scritto 2, oppure
 * salire a 0,34 e togliergli 2,04 che non ha mai scritto.
 *
 * La terza strada e' quella giusta e il server la usa gia' (vedi
 * BetslipTranslator.distribuisci nel ticket-service): la base va a tutte le
 * colonne e i centesimi che avanzano vanno UNO A TESTA alle prime. Sei
 * colonne, due euro: quattro colonne a 0,33 e due a 0,34, totale 2,00
 * esatti. Qui si rifa' lo stesso conto, e deve restare lo stesso: se la
 * schedina mostrasse una ripartizione e il server ne facesse un'altra, il
 * giocatore vedrebbe numeri diversi da quelli registrati.
 *
 * Torna { base, extra, importi } dove `extra` e' quante colonne prendono il
 * centesimo in piu' e `importi` l'importo di ogni colonna, in ordine.
 */
export function ripartisci(totale, colonne) {
  const c = Math.trunc(Number(colonne));
  const centesimi = Math.round(Number(totale) * 100);

  if (!Number.isFinite(centesimi) || centesimi <= 0 || !(c > 0)) {
    return { base: 0, extra: 0, importi: [] };
  }
  /* Sotto un centesimo per colonna la giocata non esiste: lo dice anche il
     server, con TICKET_AMOUNT_TOO_LOW. */
  if (centesimi < c) {
    return { base: 0, extra: 0, importi: [] };
  }

  const base = Math.floor(centesimi / c);
  const extra = centesimi - base * c;

  const importi = [];
  for (let i = 0; i < c; i += 1) {
    importi.push((i < extra ? base + 1 : base) / 100);
  }
  return { base: base / 100, extra, importi };
}

/**
 * Il totale di una riga del sistema, quando il giocatore ha scritto il TOTALE.
 *
 * `base` e' l'importo per colonna, `quante` le colonne della riga, `extra`
 * quante di quelle colonne prendono il centesimo in piu'. E' questo il numero
 * che va mandato al server come importo del tipo di sistema: mandare
 * base x quante significherebbe buttare via i centesimi avanzati, ed e'
 * esattamente cosi' che una giocata da 2 euro veniva registrata da 1,98.
 */
export function totaleRiga(base, quante, extra) {
  const c = Math.round(Number(base) * 100) * Math.trunc(Number(quante) || 0)
      + Math.trunc(Number(extra) || 0);
  return c / 100;
}

// ---------------------------------------------------------------------------
// Le colonne
// ---------------------------------------------------------------------------

/**
 * Quante colonne di grandezza k, con N selezioni di cui F fisse.
 *
 * La fissa sta in TUTTE le colonne, quindi le combinazioni si fanno sulle
 * restanti: C(N - F, k - F). Le righe con k minore di F non esistono e non si
 * mostrano nemmeno a zero.
 *
 * Verificato su cinque selezioni:
 *   0 fisse  5 10 10 5 1
 *   1 fissa  1  4  6 4 1
 *   2 fisse  -  1  3 3 1
 */
export function combinazioni(selezioni, fisse, grandezza) {
  const n = Number(selezioni);
  const f = Number(fisse) || 0;
  const k = Number(grandezza);
  if (k < f || k > n) return 0;
  return binomiale(n - f, k - f);
}

function binomiale(n, k) {
  if (k < 0 || k > n) return 0;
  let r = 1;
  for (let i = 1; i <= k; i += 1) {
    r = (r * (n - k + i)) / i;
  }
  return Math.round(r);
}

/**
 * Le fisse hanno senso SOLO sul sistema.
 *
 * Su singola e multipla la colonna e' una sola e le selezioni ci sono gia'
 * tutte; sull'integrale ogni colonna contiene gia' tutti gli eventi, quindi la
 * fissa e' inerte. E un esito doppiato non puo' essere fissa: due esiti dello
 * stesso evento non stanno mai nella stessa colonna, quindi l'altro non
 * avrebbe dove esistere.
 */
export function fisseAmmesse(profilo, tipoCoupon) {
  const ammesse = (profilo && profilo.fisse && profilo.fisse.ammesseSu) || ['SISTEMA'];
  return ammesse.indexOf(tipoCoupon) !== -1;
}

// ---------------------------------------------------------------------------
// Lo sviluppo delle colonne
// ---------------------------------------------------------------------------

/**
 * Gli esiti scelti, raggruppati per EVENTO.
 *
 * Il raggruppamento e' la regola strutturale dell'integrale: ogni evento
 * compare UNA VOLTA SOLA in ogni colonna, anche quando i due esiti potrebbero
 * verificarsi entrambi. Due esiti sullo stesso evento fanno due colonne, punto.
 */
export function esitiPerEvento(selezioni) {
  return (selezioni || []).map((evento) => {
    const quote = [];
    (evento.markets || []).forEach((mercato) => {
      (mercato.odds || []).forEach((q) => {
        quote.push({
          chiave: chiaveSelezione(evento, mercato, q),
          valore: Number(q.value),
          // Quando si gioca quella partita: serve al bonus, non al conto
          // della quota. Nulla quando il palinsesto non l'ha data.
          inizio: evento.matchDate || evento.date || null,
        });
      });
    });
    return { eventId: evento.eventId, quote };
  });
}

/**
 * IL NOME DI UNA SELEZIONE, uno solo per tutta la schedina.
 *
 * DENTRO C'E' L'EVENTO, e non e' un dettaglio: l'identificativo del mercato e
 * quello dell'esito vengono dal CATALOGO, non dalla partita. Il mercato "1X2"
 * ha lo stesso identificativo su tutte le partite e cosi' l'esito "1". Senza
 * l'evento davanti, la selezione "1 sul Milan" e la selezione "1 sul Napoli"
 * si chiamavano allo stesso modo: si toccava la B di una partita e si
 * accendevano le B di tutte, e da li' in poi il sistema faceva i conti
 * credendo che fossero tutte fisse.
 *
 * Sta qui, in un posto solo, perche' questo nome lo usano in quattro: la riga
 * che disegna la B, l'elenco delle fisse, lo sviluppo delle colonne e la
 * giocata che parte. Se due di loro lo scrivessero in modo diverso, le fisse
 * scelte non sarebbero le fisse giocate.
 */
export function chiaveSelezione(evento, mercato, quota) {
  const e = (evento && (evento.eventId != null ? evento.eventId : evento.id));
  return `${e}-${mercato.id}-${quota.id}-${quota.sbv || ''}`;
}

/** Una colonna per ogni combinazione di un esito per evento. */
export function colonneIntegrale(gruppi) {
  let colonne = [[]];
  (gruppi || []).forEach((g) => {
    const prossime = [];
    colonne.forEach((colonna) => {
      g.quote.forEach((q) => prossime.push(colonna.concat([q])));
    });
    colonne = prossime;
  });
  return colonne;
}

/**
 * Le colonne di un sistema: le fisse in tutte, le combinazioni sulle altre.
 *
 * `grandezze` sono le k scelte dall'utente; una grandezza minore del numero
 * di fisse non produce niente, perche' una colonna non puo' essere piu'
 * piccola delle fisse che deve contenere.
 */
export function colonneSistema(quote, chiaviFisse, grandezze) {
  const fisse = (quote || []).filter((q) => chiaviFisse.indexOf(q.chiave) !== -1);
  const libere = (quote || []).filter((q) => chiaviFisse.indexOf(q.chiave) === -1);
  const colonne = [];

  (grandezze || []).forEach((k) => {
    const quante = k - fisse.length;
    if (quante < 0 || quante > libere.length) return;
    scegli(libere, quante, 0, [], (gruppo) => colonne.push(fisse.concat(gruppo)));
  });
  return colonne;
}

function scegli(elenco, quante, da, presi, quando) {
  if (presi.length === quante) {
    quando(presi.slice());
    return;
  }
  for (let i = da; i < elenco.length; i += 1) {
    presi.push(elenco[i]);
    scegli(elenco, quante, i + 1, presi, quando);
    presi.pop();
  }
}

/**
 * I tre numeri di una giocata a piu' colonne.
 *
 * MINIMA e' la colonna che paga meno, MASSIMA quella che paga di piu', TUTTE
 * e' la somma: quanto si prende se vince tutto. Sono cose diverse e vanno
 * dette con parole diverse. Ogni colonna porta il PROPRIO bonus, calcolato
 * sui propri eventi validi — in un sistema 4-uple piu' 5-uple le quaterne
 * prendono lo scalino da quattro, che puo' valere zero.
 */
export function riassunto(colonne, importoPerColonna, scalini, giorniMassimi) {
  const vuoto = {
    colonne: 0, quotaMin: 0, quotaMax: 0, quotaTutte: 0,
    bonusMin: 0, bonusMax: 0, bonusTutte: 0,
    vincitaMin: 0, vincitaMax: 0, vincitaTutte: 0,
    importoTotale: 0,
  };
  if (!colonne || colonne.length === 0) return vuoto;

  const importo = Number(importoPerColonna) || 0;
  let quotaMin = null;
  let quotaMax = null;
  let quotaTutte = 0;
  let bonusMin = 0;
  let bonusMax = 0;
  let bonusTutte = 0;
  let vincitaMin = null;
  let vincitaMax = null;
  let vincitaTutte = 0;

  colonne.forEach((colonna) => {
    const quote = colonna.map((q) => q.valore);
    const quota = quote.reduce((a, b) => a * b, 1);
    // La quota le moltiplica TUTTE; il bonus conta solo quelle che contano.
    const bonus = bonusColonna(quota, importo, quoteCheContano(colonna, giorniMassimi), scalini);
    const vincita = arrotonda(quota * importo) + bonus;

    quotaTutte += quota;
    bonusTutte += bonus;
    vincitaTutte += vincita;

    if (quotaMin === null || quota < quotaMin) { quotaMin = quota; bonusMin = bonus; vincitaMin = vincita; }
    if (quotaMax === null || quota > quotaMax) { quotaMax = quota; bonusMax = bonus; vincitaMax = vincita; }
  });

  return {
    colonne: colonne.length,
    quotaMin: arrotonda(quotaMin),
    quotaMax: arrotonda(quotaMax),
    quotaTutte: arrotonda(quotaTutte),
    bonusMin, bonusMax, bonusTutte: arrotonda(bonusTutte),
    vincitaMin: arrotonda(vincitaMin),
    vincitaMax: arrotonda(vincitaMax),
    vincitaTutte: arrotonda(vincitaTutte),
    importoTotale: arrotonda(importo * colonne.length),
  };
}

/**
 * A CHE PUNTO SIAMO DELLA TABELLA DEL BONUS.
 *
 * La schedina dice QUANTO bonus, mai PERCHE' quello e mai COSA MANCA. Questo
 * risponde alle ultime due, e lo fa con la stessa aritmetica che calcola i
 * soldi -- `scalinoApplicabile` e `eventiValidi` sono gli stessi di sopra,
 * non una seconda versione che un giorno divergera'.
 *
 * `quoteColonna` sono le quote di UNA colonna, gia' filtrate per data: su una
 * multipla la colonna e' tutta la schedina, su un integrale sono tante quante
 * i gruppi, su un sistema quante la grandezza.
 *
 * COSA TORNA
 *   accesi     gli scalini che pagano davvero, dal piu' basso al piu' alto
 *   adesso     lo scalino che spetta a questa colonna, o niente
 *   prossimo   il primo sopra, o niente = sei al massimo
 *   mancano    quante partite servono per arrivarci, contando solo quelle che
 *              varrebbero per QUELLO scalino
 *   quota      da 0 a 1, quanto sei salito: e' quello che riempie la striscia
 *   contano    quante partite contano, e `totali` quante ce ne sono
 *
 * COSA NON TORNA
 *   Niente che prometta un bonus: `mancano` dice quante partite servono, non
 *   che aggiungerne una qualsiasi basti -- una quota sotto il minimo dello
 *   scalino non fa salire niente, ed e' per questo che `contano` e `totali`
 *   sono due numeri separati.
 *   E niente percentuale "media" su un sistema: li' ogni grandezza ha la sua,
 *   e inventarne una sola sarebbe un numero che non paga nessuno.
 */
export function passoBonus(scalini, quoteColonna) {
  const accesi = (scalini || [])
      .filter((s) => s && Number(s.percentuale) > 0 && Number(s.eventi) > 0)
      .slice()
      .sort((a, b) => Number(a.eventi) - Number(b.eventi));

  // Nessuno scalino acceso: non c'e' nessuna scala, e niente da mostrare.
  if (accesi.length === 0) return null;

  const quote = quoteColonna || [];
  const adesso = scalinoApplicabile(accesi, quote);
  const indice = adesso ? accesi.indexOf(adesso) : -1;
  const prossimo = indice + 1 < accesi.length ? accesi[indice + 1] : null;

  /* QUANTE NE MANCANO, contate come le conta lo scalino a cui si punta: una
     partita con la quota sotto il suo minimo non lo avvicina di niente. */
  let mancano = 0;
  if (prossimo) {
    mancano = Math.max(1,
        Number(prossimo.eventi) - eventiValidi(quote, prossimo.quotaMinima));
  }

  /* QUANTO SEI SALITO, da 0 a 1. Gli scalini presi contano pieni, e la strada
     verso il prossimo conta per la frazione che e'. E' l'unico numero che
     serve alla striscia, che di segmenti ne ha sempre sei: con cinque scalini
     o con trenta il disegno non cambia, cambia il numero scritto accanto. */
  let avanti = 0;
  if (prossimo) {
    const da = adesso ? Number(adesso.eventi) : 0;
    const a = Number(prossimo.eventi);
    if (a > da) {
      avanti = Math.max(0, Math.min(1,
          (eventiValidi(quote, prossimo.quotaMinima) - da) / (a - da)));
    }
  }
  const quota = Math.min(1, ((indice + 1) + avanti) / accesi.length);

  /* QUANTE CONTANO: misurate sullo scalino di cui si sta parlando -- quello
     che hai, o il primo se non ne hai nessuno. */
  const metro = adesso || accesi[0];

  return {
    accesi,
    primo: accesi[0],
    ultimo: accesi[accesi.length - 1],
    adesso,
    prossimo,
    mancano,
    quota,
    contano: eventiValidi(quote, metro.quotaMinima),
    totali: quote.length,
  };
}

// ---------------------------------------------------------------------------
// Il banco chiuso
// ---------------------------------------------------------------------------

/* I LIMITI CHE A BANCO CHIUSO POSSONO DIVENTARE UN TETTO: il loro nome nel
   contratto, il campo di `coupon` dove sta il numero, e da che parte
   stringono. L'ordine e' quello in cui la schedina li scrive: prima i soldi,
   poi le partite, poi le quote.

   La soglia di accettazione manuale non c'e' e non e' una dimenticanza: a
   banco chiuso il servizio la fa diventare la vincita massima, e arriva gia'
   come VINCITA_MAX. */
const TETTI = [
  ['IMPORTO_MAX', 'importoMax', 'max'],
  ['VINCITA_MAX', 'vincitaMax', 'max'],
  ['EVENTI_MAX', 'eventiMax', 'max'],
  ['QUOTA_MAX_SELEZIONE', 'quotaMaxSelezione', 'max'],
  ['QUOTA_MAX_TOTALE', 'quotaMaxTotale', 'max'],
  ['IMPORTO_MIN', 'importoMin', 'min'],
  ['IMPORTO_MIN_COLONNA', 'importoMinPerColonna', 'min'],
  ['EVENTI_MIN', 'eventiMin', 'min'],
  ['QUOTA_MIN_SELEZIONE', 'quotaMinSelezione', 'min'],
  ['QUOTA_MIN_TOTALE', 'quotaMinTotale', 'min'],
];

/**
 * IL BANCO CHIUSO, per come lo deve dire la schedina.
 *
 * COSA FA
 *   Legge dal profilo se il banco della skin e' chiuso e, fra i limiti del
 *   coupon corrente, tira fuori quelli che ADESSO fermano la giocata PERCHE'
 *   il banco e' chiuso: il servizio li segna uno per uno
 *   (`origine[...].tettoABancoChiuso`). Sono i tetti da scrivere mentre il
 *   giocatore compila, perche' di giorno non ci sono e non puo' saperli.
 *
 * COSA NON FA
 *   Non calcola niente: i numeri sono quelli del profilo, gia' risolti a
 *   banco chiuso dal servizio. Non decide se il banco e' chiuso guardando
 *   l'orologio. E non elenca i limiti che di notte sono uguali al giorno: per
 *   quelli la schedina fa quello che fa sempre.
 *
 * Senza `banco` nel profilo (un servizio non ancora aggiornato, o l'ospite,
 * che legge la schedina della skin) risponde «non chiuso»: nessun limite
 * inventato da questa parte.
 *
 * CHE COSA LEGGE IL GIOCATORE (`alGiocatore`) lo sceglie la skin, in
 * Impostazioni schedina, tendina 7, e il servizio lo manda nel profilo:
 *   SOLO_LIMITI         (di serie) niente «Banco chiuso»: i tetti stanno
 *                       nella riga dei limiti sotto l'importo, come di
 *                       giorno, e il rifiuto e' quello di giorno
 *   BANCO_CHIUSO        la striscia «Banco chiuso · Adesso si gioca fino
 *                       a...», senza un'ora
 *   BANCO_CHIUSO_E_ORA  la striscia con «riapre alle...»
 * Un servizio che non manda il campo (uno vecchio) qui vale «niente»: chi
 * disegna fa quello che faceva prima, la striscia, con l'ora se c'e'.
 *
 * L'ORA IN CUI RIAPRE (`riapre`) c'e' solo se il servizio la manda, e il
 * servizio la manda solo nel terzo modo, e solo se un'ora esiste: qui non si
 * guarda l'orologio e non si indovina una fascia.
 *
 * @returns {{chiuso: boolean, riapre: (string|null), alGiocatore: (string|null),
 *            tetti: Array<{quale: string, verso: string, valore: number}>}}
 */
export function bancoChiuso(profilo, limiti) {
  const banco = profilo && profilo.banco;
  /* Tutte e due le cose: il banco e' chiuso ADESSO, e i limiti che abbiamo in
     mano sono quelli di banco chiuso. Un profilo chiesto senza dire il banco
     dice «chiuso» ma porta i limiti di giorno, e i segni non ci sono. */
  const chiuso = Boolean(banco && banco.aperto === false
      && profilo.risoltoABanco === 'CHIUSO');
  if (!chiuso) {
    return {chiuso: false, riapre: null, alGiocatore: null, tetti: []};
  }

  const origine = (limiti && limiti.origine) || {};
  const tetti = [];
  TETTI.forEach(([quale, campo, verso]) => {
    const o = origine[quale];
    const valore = limiti ? limiti[campo] : null;
    if (o && o.tettoABancoChiuso === true && valore != null) {
      tetti.push({quale, verso, valore: Number(valore)});
    }
  });

  return {chiuso: true, riapre: banco.finoA || null,
    alGiocatore: banco.alGiocatore || null, tetti};
}

/* Un comportamento che manda la giocata da una persona invece di fermarla:
   di giorno «riserva» non e' un limite, e non si scrive come un limite. */
function chiamaUnaPersona(comportamento) {
  return comportamento === 'RISERVA' || comportamento === 'APPIATTIMENTO_E_RISERVA';
}

/**
 * I MASSIMI CHE VALGONO ADESSO, da scrivere sotto l'importo mentre si compila:
 * «Importo massimo 500,00 € · Vincita massima 1.000,00 € · massimo 10 partite».
 *
 * COSA FA
 *   Prende dai limiti del coupon corrente i tre massimi che il giocatore puo'
 *   leggere e su cui puo' agire con l'importo e le partite, e li da' nell'ordine
 *   in cui si scrivono: soldi, vincita, partite. Vale uguale di giorno e a
 *   banco chiuso, coi numeri che il profilo porta in quel momento: a banco
 *   chiuso arrivano gia' quelli della notte, e per quelli `dellaNotte` e' vero
 *   (il servizio li segna con `tettoABancoChiuso`), cosi' chi disegna la
 *   striscia del banco chiuso non li scrive due volte.
 *
 *   Un massimo si scrive solo se FERMA O TAGLIA DAVVERO, come fa il servizio:
 *     importo e partite   quando non mandano da una persona: «rifiuta», o
 *                         niente di scritto (per il servizio e' un rifiuto)
 *     vincita             quando non e' solo «riserva»: «rifiuta» ferma,
 *                         «appiattisce» taglia la vincita al massimo (ed e' il
 *                         comportamento di serie quando non c'e' scritto niente)
 *   Una soglia con «riserva» NON e' un limite: sopra, di giorno, la giocata
 *   parte e la guarda una persona; scriverla come massimo sarebbe falso.
 *
 *   `ferma` dice se sopra quel massimo il tasto si spegne: si' per importo e
 *   partite, per la vincita solo con «rifiuta» (con «appiattisce» la giocata
 *   parte, e la vincita si ferma al massimo: lo dice un'altra riga).
 *
 * COSA NON FA
 *   Non scrive i minimi ne' le quote: la riga e' quella dei massimi, e il
 *   resto lo dicono le righe sotto il tasto quando si sfora. Non inventa
 *   niente: senza limiti, o senza numero, la riga non c'e'.
 *
 * @returns Array<{quale: string, verso: 'max', valore: number, ferma: boolean,
 *                 dellaNotte: boolean}>
 */
export function massimiInVigore(limiti) {
  if (!limiti) return [];
  const origine = limiti.origine || {};
  const fuori = [];
  const metti = (quale, campo, siScrive, ferma) => {
    const valore = limiti[campo];
    const o = origine[quale] || {};
    if (valore == null || !siScrive(o.comportamento)) return;
    fuori.push({quale, verso: 'max', valore: Number(valore),
      ferma: ferma(o.comportamento), dellaNotte: o.tettoABancoChiuso === true});
  };
  metti('IMPORTO_MAX', 'importoMax', (c) => !chiamaUnaPersona(c), () => true);
  metti('VINCITA_MAX', 'vincitaMax', (c) => c !== 'RISERVA', (c) => c === 'RIFIUTO');
  metti('EVENTI_MAX', 'eventiMax', (c) => !chiamaUnaPersona(c), () => true);
  return fuori;
}

/**
 * QUALI TETTI SFORA la schedina cosi' com'e' compilata: quelli del banco
 * chiuso (`bancoChiuso().tetti`) e i massimi duri di giorno
 * (`massimiInVigore()` con `ferma`), che hanno la stessa forma.
 *
 * Si misurano i quattro che la schedina sa misurare mentre si compila:
 * importo (il TOTALE della giocata, come lo conta il servizio), numero di
 * partite, quota di una selezione, vincita. La quota totale e l'importo per
 * colonna NO: su sistemi e integrali valgono colonna per colonna, e rifare
 * qui quel conto vorrebbe dire avere due posti che devono dare lo stesso
 * numero. Quelli la schedina li SCRIVE soltanto; se si sforano li ferma il
 * servizio, col motivo.
 *
 * Un importo non ancora scritto e una schedina senza partite non sforano un
 * minimo: non c'e' ancora niente da misurare.
 *
 * @param misure {importo, partite, quote: number[], vincita}
 * @returns i tetti sforati, nello stesso ordine in cui sono arrivati
 */
export function tettiSforati(tetti, misure) {
  const m = misure || {};
  const importo = Number(m.importo) || 0;
  const partite = Number(m.partite) || 0;
  const quote = (m.quote || []).map(Number).filter((q) => q > 0);
  const vincita = Number(m.vincita) || 0;

  /* I SOLDI SI CONFRONTANO IN CENTESIMI. 999,99 piu' un bonus di un
     centesimo, sommati qui, possono fare 1000,0000000000001: abbastanza per
     dire «sopra il tetto» di una giocata che ci sta dentro al centesimo. */
  const centesimi = (x) => Math.round(Number(x) * 100);

  return (tetti || []).filter((t) => {
    const v = Number(t.valore);
    switch (t.quale) {
      case 'IMPORTO_MAX': return centesimi(importo) > centesimi(v);
      case 'IMPORTO_MIN': return importo > 0 && centesimi(importo) < centesimi(v);
      case 'EVENTI_MAX': return partite > v;
      case 'EVENTI_MIN': return partite > 0 && partite < v;
      case 'QUOTA_MIN_SELEZIONE': return quote.some((q) => q < v);
      case 'QUOTA_MAX_SELEZIONE': return quote.some((q) => q > v);
      case 'VINCITA_MAX': return centesimi(vincita) > centesimi(v);
      default: return false;   // quota totale, importo per colonna: li ferma il servizio
    }
  });
}

/* Dal codice che un limite ha di giorno al suo nome nel contratto. Serve
   dopo un rifiuto: la schedina deve riconoscere QUALE limite ha fermato la
   giocata per non scrivere due volte la stessa cosa. Di giorno, e a banco
   chiuso nel modo «solo i limiti», il codice e' quello del rifiuto stesso;
   negli altri modi il rifiuto e' TICKET_RESERVE_CLOSED e il codice del limite
   viaggia accanto (`codiceDelLimite`). */
const DAL_CODICE = {
  LIMIT_AMOUNT_MAX: 'IMPORTO_MAX',
  LIMIT_AMOUNT_MIN: 'IMPORTO_MIN',
  LIMIT_COLUMN_AMOUNT_MIN: 'IMPORTO_MIN_COLONNA',
  LIMIT_EVENTS_MAX: 'EVENTI_MAX',
  LIMIT_EVENTS_MIN: 'EVENTI_MIN',
  LIMIT_ODD_MIN: 'QUOTA_MIN_SELEZIONE',
  LIMIT_ODD_MAX: 'QUOTA_MAX_SELEZIONE',
  LIMIT_TOTAL_ODD_MIN: 'QUOTA_MIN_TOTALE',
  LIMIT_TOTAL_ODD_MAX: 'QUOTA_MAX_TOTALE',
  LIMIT_WIN_MAX: 'VINCITA_MAX',
};

/** Il nome del limite che ha quel codice, o null se non e' uno di questi. */
export function limiteDelCodice(codice) {
  return DAL_CODICE[codice] || null;
}

/* Sotto questo intervallo il profilo non si richiede, qualunque cosa dica la
   sua scadenza: una scadenza gia' passata -- o due orologi che non vanno
   d'accordo -- non deve diventare una richiesta dietro l'altra. */
const RINFRESCO_MINIMO_MS = 2000;
/* Si chiede un attimo DOPO la scadenza, non nell'istante esatto: alle
   23:00:00 in punto il servizio potrebbe rispondere ancora col profilo delle
   22:59, e quello scadrebbe di nuovo subito. */
const RINFRESCO_MARGINE_MS = 1000;

/**
 * FRA QUANTO VA RICHIESTO il profilo, in millisecondi da quando e' arrivato.
 *
 * Il profilo scade: dopo pochi minuti, oppure prima se il banco cambia stato
 * (`valeFinoA` lo dice gia', accorciato dal servizio). Alle 23:00 la schedina
 * gia' compilata deve scoprire i tetti della notte senza che nessuno ricarichi
 * la pagina, e alle 08:00 deve smettere di mostrarli.
 *
 * SI MISURA LA DURATA, non l'ora: `valeFinoA - emessoIl`, tutti e due istanti
 * del SERVIZIO. Confrontare `valeFinoA` con l'orologio di chi guarda farebbe
 * dipendere il rinfresco da un orologio che puo' essere avanti di dieci
 * minuti.
 *
 * @returns i millisecondi, oppure null se il profilo non dice quando scade:
 *          in quel caso non si richiede da solo, come prima.
 */
export function fraQuantoRichiedere(profilo) {
  if (!profilo || !profilo.valeFinoA || !profilo.emessoIl) return null;
  const dura = millisecondi(profilo.valeFinoA) - millisecondi(profilo.emessoIl);
  if (Number.isNaN(dura)) return null;
  return Math.max(dura + RINFRESCO_MARGINE_MS, RINFRESCO_MINIMO_MS);
}

/* Un istante del servizio in millisecondi. Arriva scritto ("2026-10-07T21:00:00Z");
   se un giorno arrivasse come numero sarebbero SECONDI, e letti come
   millisecondi farebbero durare cinque minuti un terzo di secondo -- cioe'
   una richiesta ogni due secondi da ogni schedina aperta. */
function millisecondi(istante) {
  if (typeof istante === 'number') {
    return istante < 1e11 ? istante * 1000 : istante;
  }
  return new Date(istante).getTime();
}
